/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TABLE : ROW : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	row: {
		// see table_styles for more (variants can alter styles)	

		// ----- states ----- //
		'&.processing-true': {
			'& td': {
				cursor: 'default',
				pointerEvents: 'none'
				// backgroundColor: theme.color.primary.medium.swatch,
				// color: `${theme.color.light.light.swatch} !important`
			}
		},
		'&.disabled-true': {
			cursor: 'default',
			pointerEvents: 'none',
			'& td': {
				backgroundColor: '#f1f1f1 !important',
				opacity: '.5'
			}
		},
		'&.clickable-true': {
			cursor: 'pointer'
		},

		// ----- align ----- //
		'&.align-left': {
			'& td, th': {
				textAlign: 'left'
			}
		},
		'&.align-center': {
			'& td, th': {
				textAlign: 'center'
			}
		},
		'&.align-right': {
			'& td, th': {
				textAlign: 'right'
			}
		}
	}
});